module.exports = __webpack_public_path__ + "static/media/upload.8160eeb4.svg";